
export const lan = {

    'en':[
        'Home',
        'About Us',
        'Our Team',
        'What We Do',
        'How We Do',
        'Contact Us',
        'Blogs',
        {
            'sub_menu':[
                'Learn Japanese',
                'Learn German',
                'Learn French',
                'Learn Coding',
                'Social Media Marketing',
                'Search Engine Optimization',
                'Web Development',
                'Mobile Development',
            ],
            'sub_menu_link':[
                '/japaneseclasses/',
                '/germanclasses/',
                '/frenchclasses/',
                '/codingclasses/',
                '/smo/',
                '/seo/',
                '/webdevelopment/',
                '/mobiledevelopment/'
               
               
            ]
        }
    ],

}